import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  usePartnerTableStore,
  initialPartnerColumns,
} from 'views/pages/Admin/Partner/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type PartnerColumnKey =
  | 'name'
  | 'practice_count'
  | 'operator_count'
  | 'care_navigator_count'
  | 'city'
  | 'county'
  | 'admin_count';

const PARTNER_TABLE_COLUMN_LABELS: Record<PartnerColumnKey, string> = {
  name: 'Name',
  practice_count: 'Practices',
  operator_count: 'Operators',
  care_navigator_count: 'Care Navigators',
  city: 'City / State',
  county: 'County',
  admin_count: 'Admins',
};

const ALL_FIELDS = initialPartnerColumns.map(
  c => c.field,
) as PartnerColumnKey[];

export const PartnerTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = usePartnerTableStore(s => s.hiddenColumns);
  const setHiddenColumns = usePartnerTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<PartnerColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<PartnerColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='partner_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={PARTNER_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
